export default __webpack_public_path__ + "d4de18fd83f5a7bf5ad886842974b71a.png";